import styled from 'styled-components'

export const DatItem = styled.label`
  display: block;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 6px 6px 6px 8px;
  line-height: 24px;
  border-left: 5px solid #dad5cb;
  border-bottom: 1px solid #272727;
  background-color: #1a1a1a;
`
